<p-accordion [activeIndex]="0" [multiple]="true">
    <p-accordionTab [header] ="header"></p-accordionTab>
  </p-accordion>